import { LanguageTag } from 'app/Models/Constants/LanguageTypes';
import { getDescription } from '../../Utils';
import { Helmet } from '@dr.pogodin/react-helmet';

type OldHelmetAndMetadataProps = {
    data: any;
};

export const OldHelmetAndMetadata = ({ data }: OldHelmetAndMetadataProps) => {
    const title = data.heading?.value || data.name?.toString();
    const description = getDescription(data);

    const imageUrl = data?.someTeaserImage?.value?.url || data?.mainImage?.image?.value?.url || '';

    const metaTags = (
        <>
            <title>{title}</title>
            <meta name="pageid" content={data.contentLink?.id?.toString() ?? ''} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta name="description" content={description} />
            {imageUrl && <meta property="og:image" content={imageUrl} />}
            <meta property="og:type" content="website" />
            <meta property="og:locale" content={data?.language?.name ?? LanguageTag.NORWEGIAN} />
        </>
    );

    return <Helmet htmlAttributes={{ lang: data.language?.name ?? LanguageTag.NORWEGIAN }}>{metaTags}</Helmet>;
};

export default OldHelmetAndMetadata;
